import { GetOnlineContentViewReportFileQuery, GetOnlineContentViewReportQuery } from '@bayclubs/group-classes-employee-api';

export enum OnlineContentViewReportActionTypes {
    LoadOnlineContentViewReport = '[Online Content View Report] Load action',
    GenerateOnlineContentViewReport = '[Online Content View Report] Generate action'
}

export class LoadOnlineContentViewReportAction {
    static readonly type = OnlineContentViewReportActionTypes.LoadOnlineContentViewReport;

    constructor(public payload: GetOnlineContentViewReportQuery) {}
}

export class GenerateOnlineContentViewReportAction {
    static readonly type = OnlineContentViewReportActionTypes.GenerateOnlineContentViewReport;

    constructor(public payload: GetOnlineContentViewReportFileQuery) {}
}
